// extracted by mini-css-extract-plugin
export default {"link":"UserMobMenu_link__oKKDM"};